/*
 *
 * Users constants
 *
 */
export var GET_USERS_REQUEST = 'app/Users/GET_USERS_REQUEST';
export var GET_USERS_FAILURE = 'app/Users/GET_USERS_FAILURE';
export var GET_USERS_SUCCESS = 'app/Users/GET_USERS_SUCCESS';
export var ADD_USERS_SUCCESS = 'app/Users/ADD_USERS_SUCCESS';
export var QUERY_USERS = 'app/Users/QUERY_USERS';
export var SELECT_USER = 'app/Users/SELECT_USER';
export var ADD_MEMBERS_REQUEST = 'app/Users/ADD_MEMBERS_REQUEST';
export var ADD_MEMBERS_FAILURE = 'app/Users/ADD_MEMBERS_FAILURE';
export var ADD_MEMBERS_SUCCESS = 'app/Users/ADD_MEMBERS_SUCCESS';
export var SELECT_ALL_USERS = 'app/Users/SELECT_ALL_USERS';
export var RESET_PASSWORD_REQUEST = 'app/Users/RESET_PASSWORD_REQUEST';
export var RESET_PASSWORD_FAILURE = 'app/Users/RESET_PASSWORD_FAILURE';
export var RESET_PASSWORD_SUCCESS = 'app/Users/RESET_PASSWORD_SUCCESS';
export var DELETE_USER_REQUEST = 'app/Users/DELETE_USER_REQUEST';
export var DELETE_USER_FAILURE = 'app/Users/DELETE_USER_FAILURE';
export var DELETE_USER_SUCCESS = 'app/Users/DELETE_USER_SUCCESS';
export var DELETE_BULK_USERS_SUCCESS = 'app/Users/DELETE_BULK_USERS_SUCCESS';
export var TOGGLE_ALL_USERS = 'app/Users/TOGGLE_ALL_USERS';
export var GET_LAST_ADMIN_ORGS_REQUEST = 'app/Users/GET_LAST_ADMIN_ORGS_REQUEST';
export var GET_LAST_ADMIN_ORGS_FAILURE = 'app/Users/GET_LAST_ADMIN_ORGS_FAILURE';
export var GET_LAST_ADMIN_ORGS_SUCCESS = 'app/Users/GET_LAST_ADMIN_ORGS_SUCCESS';
